import {Helper} from './Helper'

/**
 * Socium Auth storage
 *
 * @package OneSoft
 * @author AndriyGoodCoder
 */
const SociumAuthStorage = function () {
    this.live_time = 1000 * 5184000;
    this.helper = Helper();
}

SociumAuthStorage.prototype.set = function (name, value, options) {
    options = {
        path: '/',
        ...(options || {}),
        ...(!options?.expires ? {
            expires: new Date(new Date().getTime() + this.live_time).toUTCString(),
        } : {}),
    };

    if (typeof (value) === 'object') {
        value = JSON.stringify(this.helper.ConvArrToObj(value));
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }
    document.cookie = updatedCookie;
}

SociumAuthStorage.prototype.get = function (name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)" // eslint-disable-line
    ));
    let value = null;
    if (matches) {
        value = decodeURIComponent(matches[1]);
        if (this.helper.CheckIfStringIsJson(value)) {
            value = JSON.parse(value);
        }
    }
    return value;
}

SociumAuthStorage.prototype.remove = function (name) {
    this.set(name, "", {'max-age': -1});
}

export const Storage = (params) => {
    return new SociumAuthStorage();
};